import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http'
import { ApplicationConfig, importProvidersFrom } from '@angular/core'
import { MatDialogModule } from '@angular/material/dialog'
import { MatSnackBarModule } from '@angular/material/snack-bar'
import { provideAnimations } from '@angular/platform-browser/animations'
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'
import { provideRouter, withComponentInputBinding } from '@angular/router'

import { NgxMaskConfig, provideEnvironmentNgxMask } from 'ngx-mask'

import { bugfenderInitializer } from '@initializers/bugfender'
import { freedompayConfigurationInitializer } from '@initializers/freedompay-configuration'
import { locationConfigurationInitializer } from '@initializers/location-configuration'
import { recaptchaInitializer } from '@initializers/recaptcha'
import { ticketInfoInitializer } from '@initializers/ticket-info'
import { urlParamsInitializer } from '@initializers/url-params'
import { bodyInterceptor } from '@interceptors/body'
import { headersInterceptor } from '@interceptors/headers'
import { identifiersInterceptor } from '@interceptors/identifiers'
import { recaptchaInterceptor } from '@interceptors/recaptcha'

import { routes } from './app.routes'

const maskConfig: Partial<NgxMaskConfig> = {
	validation: false,
}

export const appConfig: ApplicationConfig = {
	providers: [
		provideRouter(routes, withComponentInputBinding()),
		provideAnimations(),
		provideHttpClient(
			withInterceptorsFromDi(),
			withInterceptors([
				headersInterceptor,
				bodyInterceptor,
				identifiersInterceptor,
				recaptchaInterceptor,
			])
		),
		importProvidersFrom(MatDialogModule, MatSnackBarModule),
		provideAnimationsAsync(),
		provideEnvironmentNgxMask(maskConfig),
		recaptchaInitializer,
		freedompayConfigurationInitializer,
		urlParamsInitializer,
		ticketInfoInitializer,
		locationConfigurationInitializer,
		bugfenderInitializer,
	],
}
